import { gql } from '@apollo/client';
export const UpdateHolidayApprovalRequiredMutation = gql `
    mutation UpdateHolidayApprovalRequired($siteSetId: InstitutionSetId!, $approvalRequired: Boolean!) {
        staffhours {
            settings {
                updateHolidayApprovalRequired(siteSetId: $siteSetId, approvalRequired: $approvalRequired)
            }
        }
    }
`;
export const UpdateAbsentApprovalRequiredMutation = gql `
    mutation UpdateAbsentApprovalRequired($siteSetId: InstitutionSetId!, $approvalRequired: Boolean!) {
        staffhours {
            settings {
                updateAbsentApprovalRequired(siteSetId: $siteSetId, approvalRequired: $approvalRequired)
            }
        }
    }
`;
export const UpdateSickApprovalRequiredMutation = gql `
    mutation UpdateSickApprovalRequired($siteSetId: InstitutionSetId!, $approvalRequired: Boolean!) {
        staffhours {
            settings {
                updateSickApprovalRequired(siteSetId: $siteSetId, approvalRequired: $approvalRequired)
            }
        }
    }
`;
export const UpdateChildSickApprovalRequiredMutation = gql `
    mutation UpdateChildSickApprovalRequired($siteSetId: InstitutionSetId!, $approvalRequired: Boolean!) {
        staffhours {
            settings {
                updateChildSickApprovalRequired(siteSetId: $siteSetId, approvalRequired: $approvalRequired)
            }
        }
    }
`;
